define('casino/providers/Thunderkick',['jquery'], function ($) {
    'use strict';


    function Thunderkick(casino, gameFunctions) {
        if (!(this instanceof Thunderkick)) {
            throw new TypeError('Thunderkick constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(thunderkick, game, options) {
		thunderkick.gameFunctions.showHelpButton();
		var provider = thunderkick.casino.getProvider(game);

		var $gameHolder = options.gameHolder;
		var id = 'loaded-game-' + $gameHolder.index();
		var scriptUrl = generateScriptUrl(id , game.code, provider.operatorId,
			provider.loaderUrl, provider.demoCurrency, provider.locale, undefined);
		/*
		 var splitIdAndCode = game.code.split('_');
		 if (splitIdAndCode[0] !== 'TK') {
		 throw new Error('Illegal game code not starting with TK: ' + game.code);
		 }
		 var code = splitIdAndCode[1].toLowerCase();
		 */

		/*var $gameHolder = options.gameHolder;
		var $game = $gameHolder.find('.game');
		$game.empty();
		*/
		thunderkick.gameFunctions.switchToFreeMode(game, {
			src: scriptUrl,
			gameHolder: options.gameHolder,
			type: 'iframe'
		});

    }

	function generateScriptUrl (htmlContainerId, gameId, operatorId,
								launcherUrl, currencyIso, langIso,
								playerSessionId) {


		// var operatorId = 2; //REPLACE WITH CUSTOMER OP ID

		// var langIso = "en";

		var regulator = "MGA";  //OR UKGC FOR UK

		if (window["tk"] == undefined) window["tk"] = {};
		if (tk.autoloader == undefined) tk.autoloader = {};
		if (tk.autoloader.launcher == undefined) tk.autoloader.launcher = {};

		if (playerSessionId !== undefined && playerSessionId !== "") {
			launcherUrl += "?playerSessionId="+playerSessionId;
		} else {
			launcherUrl += "?freeAccountCurrencyIso="+currencyIso;
		}

		var finalUrl = launcherUrl+"&gameId="+gameId+"&langIso="+langIso+"&allowUnity=false"
			+"&operatorId="+operatorId+"&container="+htmlContainerId+"&currencyIso="
			+currencyIso+"&regulator="+regulator;

		console.log(finalUrl);

		return finalUrl;
	}

    function realMode(thunderkick, game, options, data) {
		thunderkick.gameFunctions.showHelpButton();
		var provider = thunderkick.casino.getProvider(game);

		var $gameHolder = options.gameHolder;
		var id = 'loaded-game-' + $gameHolder.index();
		var scriptUrl = generateScriptUrl(id , game.code, provider.operatorId,
			provider.loaderUrl, provider.demoCurrency, provider.locale, data.externalSession);
		/*
		 var splitIdAndCode = game.code.split('_');
		 if (splitIdAndCode[0] !== 'TK') {
		 throw new Error('Illegal game code not starting with TK: ' + game.code);
		 }
		 var code = splitIdAndCode[1].toLowerCase();
		 */

		/*var $gameHolder = options.gameHolder;
		 var $game = $gameHolder.find('.game');
		 $game.empty();
		 */
		thunderkick.gameFunctions.switchToRealMode(game, {
			src: scriptUrl,
			gameHolder: options.gameHolder,
			type: 'iframe'
		});

    }

    Thunderkick.prototype = {
        constructor: Thunderkick,
        freeMode: function (game, options) {
            freeMode(this, game, options);
        },
        realMode: function (game, options, data) {
            realMode(this, game, options, data);
        }
    };
    return Thunderkick;
});

